import axios from 'axios';

// Basit kur servisi - backend'den kur bilgisi alır
class CurrencyService {
  constructor() {
    this.cache = null;
    this.lastFetch = null;
    this.cacheTime = 30 * 60 * 1000; // 30 dakika cache
  }

  async getCurrencyRates(_preferredSource) {
    // Cache kontrolü
    if (this.cache && this.lastFetch && (Date.now() - this.lastFetch < this.cacheTime)) {
      console.log('📦 Using cached currency data');
      return this.cache;
    }

    const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

    try {
      console.log('🔄 Backend\'den kurlar alınıyor...');

      const response = await axios.get(`${backendUrl}/api/currency/rates`, {
        timeout: 10000,
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.data?.rates) {
        throw new Error('Backend: Veri formatı hatalı');
      }

      const rates = {
        ...response.data.rates,
        lastUpdated: new Date().toISOString()
      };

      this.cache = rates;
      this.lastFetch = Date.now();

      console.log(`✅ Kurlar alındı - USD: ${this.formatRate(rates.USD.buying)}, EUR: ${this.formatRate(rates.EUR.buying)}`);
      return rates;
    } catch (error) {
      console.error('❌ Kur alınamadı:', error.message);
      throw new Error(`Kur bilgileri alınamadı: ${error.message}`);
    }
  }

  formatRate(rate) {
    if (typeof rate !== 'number') return '-.--';
    return rate.toFixed(2);
  }

  clearCache() {
    this.cache = null;
    this.lastFetch = null;
    console.log('🗑️ Currency cache cleared');
  }
}

const currencyService = new CurrencyService();

export default currencyService;
